/* Mewse Shop: tabs, filtering without page reloads, the filters sheet / drop-down,
   Show more, sorting and the colour arches. Works with sections/mewse-shop.liquid.
   Without JavaScript every chip, pill and "Clear all" is still a normal link. */
(function () {
  if (window.mewseShopLoaded) return;
  window.mewseShopLoaded = true;

  var state = {}; // per section: { tab, open }
  var phoneQuery = window.matchMedia('(max-width: 749px)');

  function shopFor(el) {
    return el.closest('[data-mw-shop]');
  }

  function sectionState(shop) {
    var id = shop.dataset.sectionId;
    if (!state[id]) state[id] = { tab: null, open: false };
    return state[id];
  }

  // Keep ?view= when previewing an alternate template, so Shopify renders the same section
  function withView(url) {
    var current = new URL(window.location.href);
    var next = new URL(url, window.location.origin);
    var view = current.searchParams.get('view');
    if (view && !next.searchParams.get('view')) next.searchParams.set('view', view);
    return next;
  }

  function sectionUrl(url, id) {
    var u = withView(url);
    u.searchParams.set('section_id', id);
    return u.toString();
  }

  function cleanUrl(url) {
    var u = withView(url);
    u.searchParams.delete('section_id');
    return u.pathname + u.search;
  }

  /* Tabs: both copies of the panel (top and pop-up) follow the same tab */
  function showTab(shop, key) {
    if (!key) return;
    var found = false;
    shop.querySelectorAll('[data-mw-tab]').forEach(function (tab) {
      var on = tab.dataset.mwTab === key;
      if (on) found = true;
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.tabIndex = on ? 0 : -1;
    });
    if (!found) return;
    shop.querySelectorAll('[data-mw-pane]').forEach(function (pane) {
      pane.hidden = pane.dataset.mwPane !== key;
    });
    sectionState(shop).tab = key;
  }

  /* Filters pop-up */
  function openPop(shop, focusFirst) {
    var pop = shop.querySelector('[data-mw-pop]');
    var btn = shop.querySelector('[data-mw-open]');
    if (!pop || !btn) return;
    pop.hidden = false;
    btn.setAttribute('aria-expanded', 'true');
    sectionState(shop).open = true;
    if (phoneQuery.matches) document.documentElement.classList.add('mw-no-scroll');
    if (focusFirst) {
      var first = pop.querySelector('.mw-tab[aria-selected="true"]') || pop.querySelector('a, button');
      if (first) first.focus();
    }
  }

  function closePop(shop, returnFocus) {
    var pop = shop.querySelector('[data-mw-pop]');
    var btn = shop.querySelector('[data-mw-open]');
    if (!pop) return;
    pop.hidden = true;
    if (btn) btn.setAttribute('aria-expanded', 'false');
    sectionState(shop).open = false;
    document.documentElement.classList.remove('mw-no-scroll');
    if (returnFocus && btn) btn.focus();
  }

  /* Swap in a freshly rendered section (filters, sorting, Clear all) */
  function load(shop, url, opts) {
    opts = opts || {};
    var id = shop.dataset.sectionId;
    var st = sectionState(shop);
    shop.setAttribute('aria-busy', 'true');
    shop.classList.add('is-loading');

    return fetch(sectionUrl(url, id))
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-mw-shop]');
        if (!fresh) throw new Error('No section');
        shop.replaceWith(fresh);
        // Replace (not push): the address keeps the filters, but Back leaves the page in one press
        if (opts.push !== false) history.replaceState({ mewseShop: true }, '', cleanUrl(url));
        showTab(fresh, st.tab);
        if (st.open) openPop(fresh, false);
        // Put focus back on the chip that was tapped, so keyboard users keep their place
        if (opts.focusKey) {
          var scope = opts.fromPop ? fresh.querySelector('[data-mw-pop]') : fresh.querySelector('.mw-panel--top');
          var again = scope && scope.querySelector('[data-mw-key="' + opts.focusKey + '"]');
          if (again) again.focus({ preventScroll: true });
        }
        if (opts.scrollToGrid) {
          var bar = fresh.querySelector('[data-mw-bar]');
          if (bar && bar.getBoundingClientRect().top < 0) {
            bar.scrollIntoView({ block: 'start' });
          }
        }
        updateStuck();
      })
      .catch(function () {
        window.location.href = cleanUrl(url);
      });
  }

  function loadMore(btn) {
    var shop = shopFor(btn);
    var grid = shop.querySelector('[data-mw-grid]');
    var wrap = btn.closest('[data-mw-more-wrap]');
    var next = btn.dataset.nextUrl;
    if (!grid || !wrap || !next) return;
    btn.disabled = true;
    btn.textContent = 'Loading…';

    fetch(sectionUrl(next, shop.dataset.sectionId))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-mw-grid]');
        if (!newGrid) throw new Error('No grid');
        var firstNew = null;
        newGrid.querySelectorAll('[data-product-card]').forEach(function (card) {
          if (!firstNew) firstNew = card;
          grid.appendChild(card);
        });
        var newWrap = doc.querySelector('[data-mw-more-wrap]');
        if (newWrap) wrap.replaceWith(newWrap);
        else wrap.remove();
        // Move keyboard focus to the first new product so keyboard users carry on from there
        if (firstNew) {
          var link = firstNew.querySelector('a');
          if (link) link.focus({ preventScroll: true });
        }
      })
      .catch(function () {
        window.location.href = cleanUrl(next);
      });
  }

  /* Stacks and styles share Shopify's Tag filter, which combines its values with "or".
     Until stacks move to their own filter, picking a stack clears any picked style and
     the other way round, so results never mix (several stacks, or several styles, still work). */
  function oneGroupOnly(link) {
    var group = link.dataset.mwGroup;
    if (!group || link.classList.contains('is-on')) return link.href;
    var shop = shopFor(link);
    var other = group === 'set' ? shop.dataset.stylePrefix : shop.dataset.setPrefix;
    if (!other) return link.href;
    var u = new URL(link.href, window.location.origin);
    var keep = u.searchParams.getAll('filter.p.tag').filter(function (v) { return v.indexOf(other) !== 0; });
    u.searchParams.delete('filter.p.tag');
    keep.forEach(function (v) { u.searchParams.append('filter.p.tag', v); });
    return u.toString();
  }

  /* Colour arches: show that colour in the main photo */
  function swapArch(arch) {
    var card = arch.closest('[data-product-card]');
    if (!card) return;
    var img = card.querySelector('[data-main-image]');
    var src = arch.dataset.variantImage;
    if (!img || !src || img.getAttribute('src') === src) return;
    card.querySelectorAll('.mw-arch').forEach(function (a) { a.classList.remove('is-active'); });
    arch.classList.add('is-active');
    img.removeAttribute('srcset');
    img.style.opacity = '0.4';
    setTimeout(function () {
      img.src = src;
      img.style.opacity = '1';
    }, 150);
  }

  /* A soft shadow under the bar once it's stuck */
  function updateStuck() {
    document.querySelectorAll('[data-mw-bar]').forEach(function (bar) {
      var top = parseFloat(getComputedStyle(bar).top) || 0;
      bar.classList.toggle('is-stuck', bar.getBoundingClientRect().top <= top + 1);
    });
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-mw-tab]');
    if (tab && shopFor(tab)) {
      showTab(shopFor(tab), tab.dataset.mwTab);
      return;
    }

    var link = e.target.closest('[data-mw-link]');
    if (link && shopFor(link)) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      e.preventDefault();
      var inPop = !!link.closest('[data-mw-pop]');
      load(shopFor(link), oneGroupOnly(link), { fromPop: inPop, focusKey: link.dataset.mwKey, scrollToGrid: inPop && !phoneQuery.matches });
      return;
    }

    var open = e.target.closest('[data-mw-open]');
    if (open && shopFor(open)) {
      var shop = shopFor(open);
      if (sectionState(shop).open) closePop(shop, false);
      else openPop(shop, true);
      return;
    }

    var close = e.target.closest('[data-mw-close]');
    if (close && shopFor(close)) {
      var s = shopFor(close);
      closePop(s, true);
      // After "Show N pieces", take people to the top of the results
      if (close.classList.contains('mw-pop__show')) {
        var bar = s.querySelector('[data-mw-bar]');
        if (bar && bar.getBoundingClientRect().top < 0) bar.scrollIntoView({ block: 'start' });
      }
      return;
    }

    var more = e.target.closest('[data-mw-more]');
    if (more) {
      loadMore(more);
      return;
    }

    var arch = e.target.closest('.mw-arch[data-variant-image]');
    if (arch) {
      swapArch(arch);
      return;
    }

    // Clicking outside the desktop drop-down closes it
    if (!phoneQuery.matches) {
      document.querySelectorAll('[data-mw-shop]').forEach(function (shop) {
        var st = sectionState(shop);
        var bar = shop.querySelector('[data-mw-bar]');
        if (st.open && bar && !bar.contains(e.target)) closePop(shop, false);
      });
    }
  });

  document.addEventListener('mouseover', function (e) {
    var arch = e.target.closest('.mw-arch[data-variant-image]');
    if (arch) swapArch(arch);
  });

  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-mw-sort]');
    if (!select) return;
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', select.value);
    u.searchParams.delete('page');
    load(shopFor(select), u.toString(), {});
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-mw-shop]').forEach(function (shop) {
        if (sectionState(shop).open) closePop(shop, true);
      });
      return;
    }
    // Arrow keys move between tabs
    var tab = e.target.closest && e.target.closest('[data-mw-tab]');
    if (tab && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) {
      var tabs = Array.prototype.slice.call(tab.parentElement.querySelectorAll('[data-mw-tab]'));
      var i = tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
      var next = tabs[(i + tabs.length) % tabs.length];
      showTab(shopFor(tab), next.dataset.mwTab);
      next.focus();
      e.preventDefault();
    }
  });

  window.addEventListener('popstate', function () {
    document.querySelectorAll('[data-mw-shop]').forEach(function (shop) {
      load(shop, window.location.href, { push: false });
    });
  });

  window.addEventListener('scroll', updateStuck, { passive: true });
  phoneQuery.addEventListener && phoneQuery.addEventListener('change', function () {
    document.querySelectorAll('[data-mw-shop]').forEach(function (shop) {
      if (sectionState(shop).open) closePop(shop, false);
    });
  });
  document.addEventListener('DOMContentLoaded', updateStuck);
})();
